import fulfilled from './fulfilled';
import pending from './pending';
import rejected from './rejected';

export default {
  'accountInfo/getAccountChannels/fulfilled': fulfilled,
  'accountInfo/getAccountChannels/pending': pending,
  'accountInfo/getAccountChannels/rejected': rejected,
};
